export const IntegrationDocumentTypeColumns = {
	model: [
		{
			label: 'Integration Id',
			key: 'key'
		},
		{
			label: 'Integration Label',
			key: 'label'
		},
		{
			label: 'Tracking System',
			key: 'trackingSystem',
			type: 'select',
			options: [
				{ label: 'AppScope', value: 'AppScope' },
				{ label: 'Acuity', value: 'Acuity' },
				{ label: 'ClassValuation', value: 'ClassValuation' },
				{ label: 'Cmp Acuity', value: 'cmpAcuity' },
			],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {

				switch ($event.value) {
					case 'Acuity':
						model[3].options = extraData.acuityOptions;
						break;

					case 'AppScope':
						model[3].options = extraData.appScopeOptions;
						break;

					case 'ClassValuation':
						model[3].options = extraData.classValuationOptions;
						break;

					case 'cmpAcuity':
						model[3].options = extraData.cmpAcuityOptions;
						break;
				}

				if (model[3].options[0]) {
					const selectedValue = model[3].options[0];

					integrationData[row.id] = {
						...row,
						...{
							trackingSystemId: selectedValue.value,
							trackingSystemLabel: selectedValue.label
						}
					};
				}
			}
		},
		{
			label: 'Tracking System Option',
			key: 'trackingSystemId',
			type: 'select',
			options: [],
			onChange: ($event: any, row: any, model: any, integrationData: any, extraData: any) => {
				let selectedValue = [];

				switch (row.trackingSystem) {
					case 'Acuity':
						selectedValue = extraData.acuityOptions.filter((option: any) => option.value === $event.value);
						break;

					case 'AppScope':
						selectedValue = extraData.appScopeOptions.filter((option: any) => option.value === $event.value);
						break;

					case 'ClassValuation':
						selectedValue = extraData.classValuationOptions.filter((option: any) => option.value === $event.value);
						break;
				}

				if (selectedValue.length) {
					integrationData[row.id] = { ...row, ...{ trackingSystemId: selectedValue[0].value, trackingSystemLabel: selectedValue[0].label } };
				}
			},
			getValue: (field: any, row: any) => {
				return row['trackingSystemLabel'];
			}
		},
		{
			label: 'Tracking System Id',
			key: 'trackingSystemId',
			disabled: true
		},
		{
			label: 'Tracking System Label',
			key: 'trackingSystemLabel',
			disabled: true
		},
		{
			label: 'Direction',
			key: 'direction',
			type: 'select',
			options: [
				{ label: 'Both', value: 'Both' },
				{ label: 'Output', value: 'Output' },
				{ label: 'Input', value: 'Input' },
			]
		}
	],
	callBacks: {
		onRowEditInit: (row: any, model: any, extraData: any) => {
			switch (row.trackingSystem) {
				case 'Acuity':
					model[3].options = extraData.acuityOptions;
					break;

				case 'AppScope':
					model[3].options = extraData.appScopeOptions;
					break;

				case 'ClassValuation':
					model[3].options = extraData.classValuationOptions;
					break;
			}
		}
	},
	formBuilderConfig: {
		key: {
			DataType: 'String',
			DisplayText: 'Integration Id',
			Name: 'key'
		},
		label: {
			DataType: 'String',
			DisplayText: 'Integration Label',
			Name: 'label',
		},
		trackingSystem: {
			DataType: 'Selector',
			DisplayText: 'Tracking System',
			Name: 'trackingSystem',
			UIControl: 'Dropdown',
			options: [
			],
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					const trackingSystemOptionsName = $event.value[0].toLowerCase() + $event.value.substring(1);
					model['trackingSystemId'].options = extraData[trackingSystemOptionsName];

					if (formGroup) {
						formGroup.get('trackingSystemId')?.setValue(null);
						formGroup.get('trackingSystemLabel')?.setValue(null);
					}
				}
			}
		},
		trackingSystemId: {
			DataType: 'Selector',
			DisplayText: 'Tracking System Option',
			Name: 'trackingSystemId',
			UIControl: 'Dropdown',
			UIOptions: {
				ShowFilter: true
			},
			UIEvents: {
				onChange: ($event: any, model: any, formGroup: any, extraData: any) => {
					let selectedValue = [];

					if (formGroup) {
						const trackingSystem = formGroup.get('trackingSystem')?.value;
						if (trackingSystem) {
							const trackingSystemOptionsName = trackingSystem[0].toLowerCase() + trackingSystem.substring(1);
							selectedValue = extraData[trackingSystemOptionsName]?.filter((option: any) => option.value === $event.value);
						}

						if (selectedValue.length) {
							formGroup.get('trackingSystemId')?.setValue(selectedValue[0].value);
							formGroup.get('trackingSystemLabel')?.setValue(selectedValue[0].label);
						}
					}
				}
			}
		},
		direction: {
			DataType: 'Selector',
			DisplayText: 'Direction',
			Name: 'direction',
			UIControl: 'Dropdown',
			options: [
				{ label: 'Both', value: 'Both' },
				{ label: 'Output', value: 'Output' },
				{ label: 'Input', value: 'Input' },
			]
		},
		trackingSystemLabel: {
			DataType: 'String',
			DisplayText: 'Tracking System Label',
			Name: 'trackingSystemLabel',
			hidden: true
		},
		id: {
			DataType: 'String',
			DisplayText: 'Id',
			Name: 'Id',
			hidden: true,
			required: false
		}
	}
};
